export const serializeFormQuery = (data: Record<string, any>) => {
  return Object.keys(data).reduce((acc, key) => ({ ...acc, [key]: data[key] }), {})
}
